import { useRouter } from "next/router";

export const useCurrentOrganizationId = (): string => {
  const router = useRouter();
  return router.query?.organization_id as string;
};
